import type { ContractSchema } from '@libs/data-access/entities'

import { httpServices } from '../../../../apis'
import type { QueryFnParams } from '../../../../types'

export type FetchModulationLocationEligibleContractsOptions = QueryFnParams<{
  queryParams: {
    team_ids?: number[]
    interval_begin: string
    interval_end: string
    include_part_times?: boolean
    include_full_times?: boolean
  }
}>

/**
 *
 */
export const fetchModulationLocationEligibleContracts = async (
  opts: FetchModulationLocationEligibleContractsOptions
) => {
  const response = await httpServices.core.get<ContractSchema[]>(
    `/modulation_location_eligible_user_contracts`,
    {
      params: opts?.queryParams
    }
  )
  return response.data
}
